require=(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"BackGame":[function(require,module,exports){
cc._RFpush(module, 'd9885GqlrJAk7js2481/K7a', 'BackGame');
// scripts\BackGame.js

'use strict';

cc.Class({
    'extends': cc.Component,

    properties: {
        // foo: {
        //    default: null,
        //    url: cc.Texture2D,  // optional, default is typeof default
        //    serializable: true, // optional, default is true
        //    visible: true,      // optional, default is true
        //    displayName: 'Foo', // optional
        //    readonly: false,    // optional, default is false
        // },
        // ...
    },

    // use this for initialization
    onLoad: function onLoad() {
        this.node.on(cc.Node.EventType.TOUCH_END, function (event) {
            cc.director.loadScene('start');
        }, this);
    }

});
// called every frame, uncomment this function to activate update callback
// update: function (dt) {

// },

cc._RFpop();
},{}],"Bag":[function(require,module,exports){
cc._RFpush(module, 'c779bYW3FBJn64u/Tg7TXvW', 'Bag');
// scripts\Bag.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        // foo: {
        //    default: null,
        //    url: cc.Texture2D,  // optional, default is typeof default
        //    serializable: true, // optional, default is true
        //    visible: true,      // optional, default is true
        //    displayName: 'Foo', // optional
        //    readonly: false,    // optional, default is false
        // },
        // ...
    },

    // use this for initialization
    onLoad: function onLoad() {},
    // called every frame, uncomment this function to activate update callback
    update: function update(dt) {
        var girl = this.game.girl.position;
        var node = this.node.position;
        var width = this.game.girl.getContentSize().height / 2;
        if (girl.y + width >= node.y) {
            // this.pickUp(girl);
            this.game.pickUp(girl, node);
            this.node.destroy();
        }
    }
});

cc._RFpop();
},{}],"End":[function(require,module,exports){
cc._RFpush(module, 'a2b23vJJW5AqbFhHNr7+bKO', 'End');
// scripts\End.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        againBtn: {
            "default": null,
            type: cc.Node
        },
        invitBtn: {
            "default": null,
            type: cc.Node
        },
        midText: {
            "default": null,
            type: cc.Node
        },
        hyperText: {
            "default": null,
            type: cc.Node
        },
        sharePanel: {
            "default": null,
            type: cc.Node
        }
    },

    // use this for initialization
    onLoad: function onLoad() {
        var _this = this;
        this.againBtn.on(cc.Node.EventType.TOUCH_END, function (event) {
            cc.director.loadScene('game');
        }, this);
        this.invitBtn.on(cc.Node.EventType.TOUCH_END, function (event) {
            _this.sharePanel.active = true;
        }, this);
        this.hyperText.on(cc.Node.EventType.TOUCH_END, function (event) {
            window.top.location.href = "xx";
        }, this);

        this.sharePanel.on(cc.Node.EventType.TOUCH_END, function (event) {
            _this.sharePanel.active = false;
        }, this);
    }

});
// called every frame, uncomment this function to activate update callback
// update: function (dt) {

// },

cc._RFpop();
},{}],"GameData":[function(require,module,exports){
cc._RFpush(module, 'd51f3LvlOpPfKiIgBM7ETyD', 'GameData');
// scripts\GameData.js

"use strict";

var global = {
    bagPosY: [-705, -637, -567, -497, -380, -310, -240, -170, 248, 418, 388, 458, 568, 638, 708, 778],
    bagPosX: [235, -242],
    speed: [3, 8, 13],
    speedIndex: 1,
    timeRemain: 20
};
window.global = global;

cc._RFpop();
},{}],"Game":[function(require,module,exports){
(function (global){
cc._RFpush(module, 'd584cNxyaZJV5/DijQM8Hdn', 'Game');
// scripts\Game.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        countBg: {
            "default": null,
            type: cc.Node
        },
        startCountDown: {
            "default": null,
            type: cc.Label
        },
        ObsLayer: {
            "default": null,
            type: cc.Layout
        },
        BagLayer: {
            "default": null,
            type: cc.Layout
        },
        road: {
            "default": null,
            type: cc.Node
        },
        girl: {
            "default": null,
            type: cc.Node
        },
        girl1: {
            "default": null,
            type: cc.Node
        },
        bags: {
            "default": [],
            type: [cc.Node]
        },

        obstacles: {
            "default": [],
            type: [cc.Node]
        },

        failedPanel: {
            "default": null,
            type: cc.Node
        },
        p_btn: {
            "default": null,
            type: cc.Node
        },
        timeRemain: {
            "default": null,
            type: cc.Label
        }
    },

    // use this for initialization
    onLoad: function onLoad() {
        clearInterval(window.timerRemainInterval);
        global.timeRemain = 15;

        global.speedIndex = 1;
        this.timerRemainInterval;
        this.timer = 1;
        this.count = 20;
        this._countTime();
        //每横排基于这个概率计算障碍物是否出现和位置
        this.probability = 0;
        this.startX = 0;
        this.startY = 0;
        this.endX = 0;
        this.endY = 0;

        this.active = false;
        this.isWin = false;
        this.isRun = false;
        cc.view.setDesignResolutionSize(640, 1010, cc.ResolutionPolicy.SHOW_ALL);
    },
    bindEvent: function bindEvent() {
        var that = this;
        this.node.on(cc.Node.EventType.TOUCH_START, function (event) {
            that.startX = event.touch.getLocation().x;
            that.startY = event.touch.getLocation().y;
        }, this);

        this.node.on(cc.Node.EventType.TOUCH_MOVE, function (event) {
            event.preventDefault();
        }, this);
        this.node.on(cc.Node.EventType.TOUCH_END, function (event) {
            var direction = "";
            that.endX = event.touch.getLocation().x;
            that.endY = event.touch.getLocation().y;

            var diffX = that.endX - that.startX;
            var diffY = that.endY - that.startY;

            if (Math.abs(diffX) >= Math.abs(diffY)) {
                if (diffX > 20) {
                    direction = "right";
                }
                if (diffX < -20) {
                    direction = "left";
                }
                that.girlRightorLeft(direction);
            } else {
                if (diffY > 20) {
                    direction = "up";
                }
                if (diffY < -20) {
                    direction = "down";
                }
                that.controlSpeed(direction);
            }
        }, this);
    },
    controlSpeed: function controlSpeed(direction) {
        var that = this;
        if (global.speedIndex < 2 && direction == "up") {
            global.speedIndex++;
        }
        if (global.speedIndex > 0 && direction == "down") {
            global.speedIndex--;
        }
    },
    _countTime: function _countTime() {
        var that = this;
        var count = setInterval(function () {
            that.timer--;
            that.startCountDown.string = '倒计时：' + that.timer.toString();
            if (that.timer <= 0) {
                clearInterval(count);
                that.countBg.removeFromParent();
                that.bindEvent();
                that.active = true;
                that.isRun = true;

                window.timerRemainInterval = setInterval(function () {
                    global.timeRemain--;
                }, 1000);
            }
        }, 1000);
    },
    girlRightorLeft: function girlRightorLeft(direction) {
        var that = this;
        var posX = that.girl.x;
        window.girl = that.girl;
        window.girl1 = that.girl1;
        //console.log(posX);
        //判断运动边缘
        if (posX >= 100 && direction == "right" || posX <= -100 && direction == "left") return;
        if (direction) {
            direction == "right" ? direction = 100 : direction = -100;
            this.girl.runAction(cc.moveBy(0.1, cc.p(direction, 0)));
        }
    },

    //捡拾礼物；
    pickUp: function pickUp(bag) {
        //console.log(girlPos,bagPos);
        var rotate = cc.rotateTo(0.3, 0);
        console.log(this.girl.getPosition());
        var move = cc.jumpTo(0.3, cc.p(this.girl.x, this.girl.y + 100), 100, 1);
        var action = cc.spawn(rotate, move);
        bag.runAction(cc.sequence(action, cc.callFunc(function () {
            bag.active = false;
        }, this)));
        cc.audioEngine.playEffect("res/raw-assets/textures/audio/jump1.mp3");
    },

    onPause: function onPause() {
        // cc.director.pause();
        this.girl.stopAllActions();
        this.road.stopAllActions();
        this.pauseLabel.active = true;
        this.isRun = false;
        this.pauseLabel.on(cc.Node.EventType.TOUCH_END, function (event) {
            cc.director.loadScene('game');
        }, this);
    },

    girlRun: function girlRun(speed) {
        // if(this.girl.position.y>800|| this.road.position.y<-480) return;
        this.girl.y += speed;
        // this.girl.runAction(cc.sequence(cc.moveBy(1,cc.p(0,speed)),
        //         cc.callFunc(function(){
        //         },this)
        //     ));
        // if(this.girl.position.y<600){
        //     this.girl.runAction(cc.sequence(cc.moveBy(1,cc.p(0,speed)),
        //         cc.callFunc(function(){
        //         },this)
        //     ));
        // }
        // if(this.road.position.y>-400){
        //     this.road.runAction(cc.sequence(cc.moveBy(1,cc.p(0,-speed)),
        //         cc.callFunc(function(){
        //             // alert("win")
        //         },this)
        //     ));
        // }
    },
    gameOver: function gameOver() {
        cc.director.loadScene('end');
    },
    roadRun: function roadRun(speed) {
        this.road.y -= speed;
        // this.road.runAction(cc.sequence(cc.moveBy(1,cc.p(0,-speed)),
        //     cc.callFunc(function(){
        //         // alert("win")
        //     },this)
        // ));
    },

    showFailedPanel: function showFailedPanel() {
        var that = this;
        that.girl.active = false;
        that.girl1.active = true;
        that.girl1.setPosition(that.girl.getPosition());
        that.failedPanel.active = true;
        cc.audioEngine.playEffect("res/raw-assets/textures/audio/hit.mp3");
        that.p_btn.on(cc.Node.EventType.TOUCH_END, function (event) {
            cc.director.loadScene('game');
        }, this);

        setTimeout(function () {
            that.failedPanel.setPosition(cc.p(0, 0));
        }, 2000);
    },

    update: function update(dt) {
        var that = this;
        if (!that.girl.active) {
            return;
        }
        this.timeRemain.string = "剩余:" + global.timeRemain;
        if (global.timeRemain <= 0) {
            that.showFailedPanel();
        }
        console.log(that.girl.y);
        if (this.active && !this.isWin) {
            if (that.girl.y < 3900 && that.road.y > -3750) {
                that.girlRun(global.speed[global.speedIndex]);
                that.roadRun(global.speed[global.speedIndex]);
            } else if (that.girl.y < 3900 && that.road.y <= -3750) {
                that.girlRun(global.speed[global.speedIndex]);
            } else if (that.girl.y >= 3900 && that.road.y > -3750) {
                that.roadRun(global.speed[global.speedIndex]);
            } else if (that.girl.y >= 3900 && that.road.y <= -3750) {
                that.isWin = true;
                this.gameOver();
            }
        }

        for (var i in this.obstacles) {
            var obstacle = this.obstacles[i];
            var diffX = obstacle.x - this.girl.x;
            var diffY = obstacle.y - this.girl.y;

            if (Math.sqrt(diffX * diffX + diffY * diffY) < 80) {
                that.showFailedPanel();
            }
        }

        for (var i in this.bags) {
            var bag = this.bags[i];
            if (bag.y < this.girl.y + 100) {
                this.pickUp(bag);
                this.bags.splice(i, 1);
            }
        }
    }
});

cc._RFpop();
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"Obstacle":[function(require,module,exports){
cc._RFpush(module, 'd22f6kQchZAzrxvY+/FoDon', 'Obstacle');
// scripts\Obstacle.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        // foo: {
        //    default: null,
        //    url: cc.Texture2D,  // optional, default is typeof default
        //    serializable: true, // optional, default is true
        //    visible: true,      // optional, default is true
        //    displayName: 'Foo', // optional
        //    readonly: false,    // optional, default is false
        // },
        // ...
    },

    // use this for initialization
    onLoad: function onLoad() {
        this.node.on(cc.Node.EventType.TOUCH_START, function (event) {
            // this.node.dispatchEvent( new cc.Event('candy_die', true) );
            // this.node.removeFromParent();
        }, this);

        // var pos = this.game.road.convertToWorldSpace(this.node.position);
        // console.log(this.node.position);
    },
    // called every frame
    update: function update(dt) {
        // 每帧判断和主角之间的距离是否小于收集距离
        var pos = this.node.position;
        var girl = this.game.girl.position;
        // console.log(Math.abs(girl.y-pos.y));
        var that = this;
        // console.log(Math.abs(girl.x-pos.x));
        if (Math.abs(girl.y - pos.y) < 70 && Math.abs(girl.x - pos.x) < 70) {
            that.game.onPause();
        }
    }
});

cc._RFpop();
},{}],"StartBtn":[function(require,module,exports){
cc._RFpush(module, '280c3rsZJJKnZ9RqbALVwtK', 'StartBtn');
// scripts\StartBtn.js

"use strict";

cc.Class({
    "extends": cc.Component,

    properties: {
        ruleBtn: {
            "default": null,
            type: cc.Node
        },
        backBtn: {
            "default": null,
            type: cc.Node
        },
        rulesBg: {
            "default": null,
            type: cc.Node
        },
        gameBtn: {
            "default": null,
            type: cc.Node
        }
    },
    onLoad: function onLoad() {
        this.gameBtn.on(cc.Node.EventType.TOUCH_END, function (event) {
            cc.director.loadScene('game');
        }, this);
        this.ruleBtn.on(cc.Node.EventType.TOUCH_END, function (event) {
            this.rulesBg.active = true;
        }, this);
        this.backBtn.on(cc.Node.EventType.TOUCH_END, function (event) {
            this.rulesBg.active = false;
        }, this);
        cc.audioEngine.playMusic("res/raw-assets/textures/audio/HappyGoLuckyMAS.mp3", true);
    },

    // called every frame
    update: function update(dt) {}
});

cc._RFpop();
},{}]},{},["StartBtn","End","Bag","Obstacle","GameData","Game","BackGame"]);
